import en from './locale/en';
import ja from './locale/ja';
import ko from './locale/ko';
import zh_TW from './locale/zh_TW';

export default {
  en,
  ja,
  ko,
  zh_TW,
};
